import { createContext, useContext } from 'react';

export interface DialogContext {}

export const dialogContext = createContext<DialogContext>({});

export const useDialogContext = () => useContext(dialogContext);
